import styled from 'styled-components';

import bg from '~/assets/error_img.png';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;
  min-width: 100vw;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-size: 200% 200%;

  section {
    color: #ccff00;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    min-height: 50vh;
    width: 70%;
    background: inherit;
    border-radius: 12px;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  }
  animation: movingBackground 10s linear infinite;

  @keyframes movingBackground {
    0% {
      background-position: 0% 50%;
    }
    25% {
      background-position: 50% 100%;
    }
    50% {
      background-position: 100% 50%;
    }
    75% {
      background-position: 50% 100%;
    }
    100% {
      background-position: 100% 50%;
    }
  }
`;
